import { render, staticRenderFns } from "./activityPage.vue?vue&type=template&id=2f2a5baa"
import script from "./activityPage.vue?vue&type=script&lang=js"
export * from "./activityPage.vue?vue&type=script&lang=js"
import style0 from "./activityPage.vue?vue&type=style&index=0&id=2f2a5baa&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports